import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-pager";
import "./../../bindings/bao-upload";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-toolbar2";
import "./../../factories/bao-dialog";
import "./../../factories/child-tab-view-model";
import "./../../factories/node-view-model";
// bao migrate - module not found: import "modules/synoset-module";
import "./../../factories/tab-page";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/sorting";
import myDialog from "./../dialogs/service-category-change-dialog";
import ServiceLevelAgreementServiceCategoryDialog from "./../dialogs/service-level-agreement-service-category-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
//import NodeViewModel = window.baorequire("Factories/NodeViewModel");
class ServiceCategoryTabModel extends ChildTabViewModel {
    Bao = Bao;
    ServiceProvider: any;
    TabPage: TabPage;
    PageIndex = ko.observable(0);
    PageSize = ko.observable(20);
    TotalRows = ko.observable(0);
    Sorting = ko.observableArray();
    ServiceCategoryCollection = ko.observableArray([]);
    SelectedServiceCategoryRow = ko.observable({});
    Dialog: any;
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.TabPage = tabPage;
        this.ServiceProvider = parent;
        this.PageIndex.subscribe(() => {
            this.RefreshGrid();
        });
        this.PageSize.subscribe(() => {
            this.RefreshGrid();
        });
        this.Sorting.subscribe(() => {
            this.RefreshGrid();
        });
        this.SelectedServiceCategoryRow.subscribe(() => {
            this.enableDisableButton("ServiceCategoryEdit", false);
            this.enableDisableButton("ServiceCategoryDelete", false);
            this.enableDisableButton("ChangeServiceComponentsServiceLevelAgreement", false);
            this.enableDisableButton("AddServiceCategory", true);
            if (this.SelectedServiceCategoryRow() != null) {
                this.enableDisableButton("ServiceCategoryEdit", true);
                this.enableDisableButton("ServiceCategoryDelete", true);
                this.enableDisableButton("ChangeServiceComponentsServiceLevelAgreement", true);
            }
        });
   
    }

    _deleteMessage = Bao.Session.GetMessage("msgDeleteServiceCategory");
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "ServiceCategoryAdd":
                this.ShowServiceCategoryDialog(this.ServiceProvider.ServiceProviderId, null);
                break;
            case "ServiceCategoryEdit":
                if (this.SelectedServiceCategoryRow() != null) {
                    this.ShowServiceCategoryDialog(this.ServiceProvider.ServiceProviderId, this.SelectedServiceCategoryRow()["ServiceCategoryId"]);
                }
                break;
            case "ServiceCategoryDelete":
                if (this.SelectedServiceCategoryRow() != null) {
                    let yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, this._deleteMessage, "yesno");
                    yesNoDialog.DialogResult.subscribe((result) => {
                        if (result === true) {
                            this.DeleteServiceCategory(this.ServiceProvider.ServiceProviderId(), this.SelectedServiceCategoryRow()["ServiceCategoryId"]);
                        }
                    });
                }
                break;
            case "ChangeServiceComponentsServiceLevelAgreement":
                if (this.SelectedServiceCategoryRow() != null) {
                    this.ShowServiceCategoryChangeDialog(this.ServiceProvider.ServiceProviderId, this.SelectedServiceCategoryRow()["ServiceCategoryId"]);
                }
                break;
        }
    };
    RefreshGrid() {
        this.TabPage.IsLoading(true);
        return Bao.post("ServiceProviderTab/GetServiceCategoryCollection", JSON.stringify({
            sessionTabId: this.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: this.ServiceProvider.ServiceProviderId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedServiceCategoryRow(null);
            this.TotalRows(0);
            this.ServiceCategoryCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                this.ServiceCategoryCollection(searchResult.Models);
                this.TotalRows(searchResult.TotalRows);
            }
        });
    }
    ;
    _msgCancel = Bao.Session.GetMessage("msgCancel");
    _msgOk = Bao.Session.GetMessage("msgOk");
    AddServiceCategory(serviceProviderId, serviceCategory) {
        this.TabPage.IsLoading(true);
        return Bao.post("ServiceProviderTab/AddServiceCategory", JSON.stringify({
            sessionTabId: this.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: serviceProviderId,
            serviceCategory: this.MinimizeEntity(serviceCategory)
        }), () => {
            this.ServiceProvider.TabPage.DirtyFlag(true);
            this.RefreshGrid();
        });
    }
    ;
    DeleteServiceCategory(serviceProviderId, serviceCategoryId) {
        return Bao.post("ServiceProviderTab/DeleteServiceCategory", JSON.stringify({
            sessionTabId: this.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: serviceProviderId,
            serviceCategoryId: serviceCategoryId
        }), () => {
            this.ServiceProvider.TabPage.DirtyFlag(true);
            this.RefreshGrid();
        });
    }
    ;
    EditServiceCategory(item) {
        this.ShowServiceCategoryDialog(this.ServiceProvider.ServiceProviderId(), item.ServiceCategoryId);
    }
    ;
    ShowServiceCategoryDialog(serviceProviderId, serviceCategoryId) {
        this.TabPage.IsLoading(true);
        Bao.post("ServiceProviderTab/ShowServiceCategoryDialog", JSON.stringify({
            sessionTabId: this.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: serviceProviderId,
            serviceCategoryId: serviceCategoryId
        }), (value) => {
            this.CreateDialog();
            this.Dialog.ViewModel(ko.map.fromJS(value.Model));
            this.Dialog.ViewModel().SelectedActivity = ko.observable();
            this.Dialog.ViewModel().SelectedActivity.subscribe((newValue) => {
                if (newValue != null) {
                    this.Dialog.ViewModel().ActivityNumber(newValue.Number);
                    this.Dialog.ViewModel().ActivityName(newValue.Name);
                    this.Dialog.ViewModel().ActivityUnitName(newValue.ActivityUnitName);
                    this.Dialog.ViewModel().ServiceCategory(newValue.Number + " / " + newValue.Description);
                }
                else {
                    this.Dialog.ViewModel().ActivityUnitName("");
                    this.Dialog.ViewModel().ServiceCategory("");
                }
            });
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
            this.TabPage.IsLoading(false);
        });
    }
    ;
    ShowServiceCategoryChangeDialog(serviceProviderId, serviceCategoryId) {
        this.TabPage.IsLoading(true);
        let dialog = new myDialog(this.TabPage, this);
        dialog.init().then(() => {
            dialog.Show(this.ServiceProvider.TabPage.SessionTabId, serviceProviderId, serviceCategoryId, this.SelectedServiceCategoryRow()["Price"]);
            dialog.DialogResult.subscribe((dialogResult) => {
                if (dialogResult == true) {
                    let selectedSlaItems = JSON.parse(JSON.stringify(dialog.SlaCollection().filter(sla => sla.Selected())));
                    if (selectedSlaItems.length > 0) {
                        this.TabPage.IsLoading(true);
                        //Anmerkung: Es würde auch reichen nur die Ids zu schicken
                        selectedSlaItems.forEach(configurationItem => delete configurationItem.Selected);
                        if (dialog.ChangeExistingServices() == "0") {
                            //Lege sie für alle selektierten Elemente neu an
                            //Schicke die Liste mit den selektierten Elementen und AMOUNT, TARIF, RHYTHM an den Server
                            //Anmerkung: Es würde auch reichen nur die Ids zu schicken
                            Bao.post("ServiceProviderTab/AddServiceCategoryToSla", JSON.stringify({
                                serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                slaCollection: ko.map.toJS(selectedSlaItems),
                                amount: dialog.AmountAdd(),
                                price: dialog.ServiceCategoryPrice(),
                                rhythmId: dialog.RhythmAdd()["BillingRhythmId"]
                            }), (value) => {
                                if (value.Result == true) {
                                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddServiceCategoryToSla.Succeeded"), "info");
                                }
                                else {
                                    let message = Bao.Session.GetMessage("msgAddServiceCategoryToSla.Failed");
                                    message.$deferred.then((result) => {
                                        message(message().replace('{0}', value.Message));
                                    });
                                    new BaoDialogViewModel(Bao.Session.ApplicationName, message, "info");
                                }
                                //else BaoMessageBox Misserfolg
                                this.TabPage.IsLoading(false);
                            });
                        }
                        else //*info* dialog.ChangeExistingServices() == "1"
                         {
                            if (dialog.UpdateAmountAndPrice() == "1") {
                                if (dialog.UpdateServiceComponents() == true && dialog.UpdateAmountAndPriceFiltered() == true) {
                                    //Nur auf Menge und Preis gefiltert anpassen
                                    Bao.post("ServiceProviderTab/UpdateAmountAndPrice", JSON.stringify({
                                        serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                        slaCollection: ko.map.toJS(selectedSlaItems),
                                        amount: dialog.AmountUpdate(),
                                        price: dialog.ServiceCategoryPrice(),
                                        month: dialog.Month(),
                                        year: dialog.Year(),
                                        updateServiceComponents: true,
                                        updateAll: false,
                                        oldPrice: dialog.TarifFilter(),
                                        oldAmount: dialog.AmountFilter()
                                    }), (value) => {
                                        if (value.Result == true) {
                                            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddServiceCategoryToSla.Succeeded"), "info");
                                        }
                                        else {
                                            let message = Bao.Session.GetMessage("msgAddServiceCategoryToSla.Failed");
                                            message.$deferred.then((result) => {
                                                message(message().replace('{0}', value.Message));
                                            });
                                            new BaoDialogViewModel(Bao.Session.ApplicationName, message, "info");
                                        }
                                        //else BaoMessageBox Misserfolg
                                        this.TabPage.IsLoading(false);
                                    });
                                }
                                else {
                                    if (dialog.UpdateServiceComponents() == true) {
                                        //Alle ServiceComponents anpassen
                                        Bao.post("ServiceProviderTab/UpdateAmountAndPrice", JSON.stringify({
                                            serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                            slaCollection: ko.map.toJS(selectedSlaItems),
                                            amount: dialog.AmountUpdate(),
                                            price: dialog.ServiceCategoryPrice(),
                                            month: dialog.Month(),
                                            year: dialog.Year(),
                                            updateServiceComponents: true
                                        }), (value) => {
                                            if (value.Result == true) {
                                                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddServiceCategoryToSla.Succeeded"), "info");
                                            }
                                            else {
                                                let message = Bao.Session.GetMessage("msgAddServiceCategoryToSla.Failed");
                                                message.$deferred.then((result) => {
                                                    message(message().replace('{0}', value.Message));
                                                });
                                                new BaoDialogViewModel(Bao.Session.ApplicationName, message, "info");
                                            }
                                            //else BaoMessageBox Misserfolg
                                            this.TabPage.IsLoading(false);
                                        });
                                    }
                                    else {
                                        if (dialog.UpdateServiceComponents() == false) {
                                            //Radiobutton: Menge und Preis aktualisieren
                                            Bao.post("ServiceProviderTab/UpdateAmountAndPrice", JSON.stringify({
                                                serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                                slaCollection: ko.map.toJS(selectedSlaItems),
                                                amount: dialog.AmountUpdate(),
                                                price: dialog.ServiceCategoryPrice(),
                                                month: dialog.Month(),
                                                year: dialog.Year()
                                            }), (value) => {
                                                if (value.Result == true) {
                                                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddServiceCategoryToSla.Succeeded"), "info");
                                                }
                                                else {
                                                    let message = Bao.Session.GetMessage("msgAddServiceCategoryToSla.Failed");
                                                    message.$deferred.then((result) => {
                                                        message(message().replace('{0}', value.Message));
                                                    });
                                                    new BaoDialogViewModel(Bao.Session.ApplicationName, message, "info");
                                                }
                                                //else BaoMessageBox Misserfolg
                                                this.TabPage.IsLoading(false);
                                            });
                                        }
                                    }
                                }
                            }
                            else //*info* dialog.UpdateAmountAndPrice() == "0"
                             {
                                //Checkbox: Verechnungsart aktualisieren
                                Bao.post("ServiceProviderTab/UpdateBillingRhythm", JSON.stringify({
                                    serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                                    slaCollection: ko.map.toJS(selectedSlaItems),
                                    rhythmId: dialog.RhythmEdit()["BillingRhythmId"]
                                }), (value) => {
                                    if (value.Result == true) {
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgAddServiceCategoryToSla.Succeeded"), "info");
                                    }
                                    else {
                                        let message = Bao.Session.GetMessage("msgAddServiceCategoryToSla.Failed");
                                        message.$deferred.then((result) => {
                                            message(message().replace('{0}', value.Message));
                                        });
                                        new BaoDialogViewModel(Bao.Session.ApplicationName, message, "info");
                                    }
                                    //else BaoMessageBox Misserfolg
                                    this.TabPage.IsLoading(false);
                                });
                            }
                            //Ändere alle selektierte Elemente
                            //let questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgServiceLevelAgreementServiceCategory.ReallyChangeAllServices"), "question");
                            //questionDialog.DialogResult.subscribe((result) => {
                            //    if (result === true) {
                            //        Bao.post("ServiceLevelAgreementTab/Change", JSON.stringify({
                            //            oldAmount: dialog.Amount(),                                                //Werte des Dialoges
                            //            oldPrice: dialog.Tarif(),
                            //            newAmount: this.SelectedServiceCategoryRow()["Amount"],                    //vom zuvor selektierten Service,
                            //            newPrice: this.SelectedServiceCategoryRow()["Price"],
                            //            serviceCategoryId: this.SelectedServiceCategoryRow()["ServiceCategoryId"],
                            //            serviceLevelAgreementId: this.ServiceLevelAgreement.ServiceLevelAgreementId(),
                            //            month: dialog.Month(),
                            //            year: dialog.Year(),
                            //            changeAll: true
                            //        }), (result) => {
                            //            if (result.Result == true) {
                            //                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithSuccess"), "info");
                            //            }
                            //            else {
                            //                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCompletedWithFailure"), "info");
                            //            }
                            //        });
                            //    }
                            //});
                        }
                    }
                    else {
                        //BAO InfoBox: kein SLA selektiert
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgmsgAddServiceCategoryToSla.NoSlaSelected"), "info");
                    }
                }
            });
        });
    }
    ;
    enableDisableButton(actionKey, enabled) {
    }
    ;
    ValidateDialog(serviceCategoryModel) {
        //CompleteCheck:
        let isComplete = true;
        if (serviceCategoryModel.ExecutingServiceProviderId() == null) {
            isComplete = false;
        }
        if (serviceCategoryModel.ActivityId() == null) {
            isComplete = false;
        }
        if (serviceCategoryModel.Price() == null) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(serviceCategoryModel.ServiceCategory()) == null) {
            isComplete = false;
        }
        if (serviceCategoryModel.BillingTypeId() == null) {
            isComplete = false;
        }       
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return false;
        }
        return true;
    }
    ;
    //tab interface members
    Refresh() {
        let def = $.Deferred();
        Bao.post("ServiceProviderTab/ResetServiceCategory", JSON.stringify({ sessionTabId: this.ServiceProvider.TabPage.SessionTabId }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
    ;
    Save() {
        return Bao.post("ServiceProviderTab/SaveServiceCategoryCollection", JSON.stringify({
            sessionTabId: this.ServiceProvider.TabPage.SessionTabId,
            serviceProviderId: this.ServiceProvider.ServiceProviderId(),
            saveTime: this.ServiceProvider.SaveTime()
        }));
    }
    ;
    loaded() {
        return this.RefreshGrid();
    }
    ;
    MinimizeEntity(serviceCategory) {
        let model = null;
        if (typeof serviceCategory === "undefined") {
            model = ko.map.toJS(this, true);
        }
        else {
            model = ko.map.toJS(serviceCategory);
        }
        for (let o in model) {
            if (typeof model[o] === "object" || typeof model[o] === "function") {
                delete model[o];
            }
        }
        return model;
    }
    CreateDialog(){
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("750px");
        this.Dialog.Buttons([{
                Title: this._msgOk,
                Click: () => {
                    if (!this.ValidateDialog(this.Dialog.ViewModel())) {
                        return;
                    }
                    this.AddServiceCategory(this.ServiceProvider.ServiceProviderId(), this.Dialog.ViewModel());
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true)
            }, { Title: this._msgCancel, Click: () => { this.Dialog.Close(); }, Enabled: ko.observable(true) }]);
    }
}
export default ServiceCategoryTabModel;